import { buildCURKeywords } from "./buildCURKeywords";
import { buildTickerKeywords } from "./buildTickerKeywords";

interface BuildTickerKeywordsForQuoteType {
  type: string;
  displayName: string;
  ticker: string;
  securityName: string;
}

export default function buildTickerKeywordsForQuoteType({
  type,
  displayName,
  ticker,
  securityName,
}: BuildTickerKeywordsForQuoteType) {
  switch (type) {
    case "INDF":
    case "IND":
    case "INDS":
    case "INDN":
      return buildTickerKeywords(displayName, ticker, [
        "analysis",
        "chart",
        "profile",
        "description",
      ]);
    case "ETF":
    case "ETP":
      return buildTickerKeywords(displayName, ticker, [
        "chart",
        "assets",
        "profile",
        "data",
      ]);
    case "CUR":
      return buildCURKeywords({ displayName, ticker, securityName });
    case "COM":
      return buildTickerKeywords(displayName, ticker);
    case "MMF":
      return buildTickerKeywords(displayName, ticker);
    case "COR":
    case "GOV":
      return buildTickerKeywords(displayName, ticker);
    case "CEFH":
    case "CEF":
      return buildTickerKeywords(displayName, ticker);
    case "OEF":
    case "OEFH":
      return buildTickerKeywords(displayName, ticker, [
        "ticker",
        "chart",
        "quote",
      ]);
    case "EQT":
    default: {
      return `${displayName}, ${displayName} stock, ${displayName} stock price, ${displayName} stock charts, ${ticker} price quote, ${ticker} quote, ${displayName} news, ${ticker}, ${ticker} stock, ${ticker} stock price, ${ticker} stock charts, stock, stock price, stock charts`;
    }
  }
}
